import React from 'react';
import {
    ServicesPerMonthPerYearPercentage,
    ServicesPerMonthPerYearTotal
} from '../../../Common/Services/charts/apex-charts';
import { useServicesChartsDataContext } from '../../../Common/Services/hooks/useServicesChartsDataContext';
import { ServicesPerYearDonut } from '../../../Common/Services/charts/apex-charts/ServicesPerYearDonut';
import Loading from '../../../../Dashboards/Common/Loading';

const ComplexetyLevel = () => {
    const { isLoading, data } = useServicesChartsDataContext();

    if (isLoading) {
        return <Loading />;
    }

    return (
        <>
            <div className="charts-row-dashboards">
                <ServicesPerYearDonut height={350} />
            </div>
            <div className="charts-side-by-side-dashboards">
                <ServicesPerMonthPerYearPercentage height={400} />
                <ServicesPerMonthPerYearTotal height={400} />
            </div>
        </>
    );
};

export default ComplexetyLevel;
